import { useCallback, useEffect, useRef } from 'react';
import { useNotification } from '../contexts/NotificationContext';
import { isCanceledError, isReportedError } from '../helpers/reportedErrors';

// Returns a stable notifyError(error, message). Skips cancelled requests and errors ApiCall already showed.
export const useErrorNotification = () => {
    const { showNotification } = useNotification();

    const latest = useRef(showNotification);
    useEffect(() => {
        latest.current = showNotification;
    });

    return useCallback((error, message) => {
        if (isCanceledError(error)) return;
        console.error(error);
        if (isReportedError(error)) return;
        latest.current(message, 'danger');
    }, []);
};
